import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-137" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-138" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-139" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-140" data-mp="tyv5tcf1sfy9">🏆 </span>Spezielles Launch-Angebot
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-141" data-mp="u0xv1u8dm51x">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-142" data-mp="13x15rohanc0h">
            YOGA BEREIT™ Pack
          </span>

          <dl data-id="element-143" data-mp="2fbohaa9mdmj1">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-144" data-mp="2fad3dhmgmye7">
                <dt className="text-ink/80" data-id="element-145" data-mp="pj5uqoeuwie0">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-146" data-mp="ujbqogs5sr1w">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-147" data-mp="zioaesnqhi09">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-148" data-mp="13jq9n9hnhu28">Gesamtwert:</dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-149" data-mp="6tprhtbsebtw">€129</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-150" data-mp="bskhbf8690ni">
            Nur für heute
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-151" data-mp="fsup8xfiy150">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-152" data-mp="kmp2pj4jdjvn">
              🏆
            </span>
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-153" data-mp="3k8dnp18sgvqu">€19</span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-154" data-mp="3o84jjjd6a228">
            <span aria-hidden="true" data-id="element-155" data-mp="vdnxorfz47at">💳 </span>Einmalzahlung, lebenslanger Zugriff. Kein Abo.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-156" data-mp="qetgftxnmqst" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-157" data-mp="155tqu4hyourl">
            Sofort-Download · Einmalzahlung · Lebenslanger Zugriff · 7 Tage Garantie
          </p>
        </div>
      </div>
    </section>;
}